import { render, staticRenderFns } from "./statisticsList.vue?vue&type=template&id=5354fc8a&scoped=true"
import script from "./statisticsList.vue?vue&type=script&lang=js"
export * from "./statisticsList.vue?vue&type=script&lang=js"
import style0 from "./statisticsList.vue?vue&type=style&index=0&id=5354fc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354fc8a",
  null
  
)

export default component.exports